export default __webpack_public_path__ + "static/media/GP.a78ed4ab.svg";